import styled from 'shared/utils/styled';

export const NotificationTitle = styled('h3')(({ theme }) => ({
  margin: 0,
  padding: 0,
  fontFamily: 'NeoSansStd',
  fontSize: theme.typography.pxToRem(24),
  fontWeight: 500,
  color: '#000',
}));

export const NotificationDescription = styled('p')(({ theme }) => ({
  margin: 0,
  padding: 0,
  fontFamily: 'NeoSansStd',
  fontSize: theme.typography.pxToRem(16),
  color: theme.palette.primary.main,
  wordBreak: 'break-word',
}));
